var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01904 8.53998C4.52833 7.80593 3.5 6.27062 3.5 4.5C3.5 2.019 5.519 0 8 0C10.4815 0 12.5 2.019 12.5 4.5C12.5 6.18941 11.5641 7.66461 10.1833 8.43398C13.2787 9.47023 15.5 12.2465 15.5 15.5C15.5 15.7765 15.276 16 15 16H8.43199H8.06801H1.5C1.224 16 1 15.7765 1 15.5C1 12.3518 3.07992 9.65037 6.01904 8.53998ZM8 1C6.07 1 4.5 2.57 4.5 4.5C4.5 6.43 6.07 8 8 8C9.9295 8 11.5 6.43 11.5 4.5C11.5 2.57 9.9295 1 8 1ZM2.0205 15C2.27749 11.8793 4.91789 9.36812 8.25 9.03705C11.5821 9.36812 14.2225 11.8793 14.4795 15H8.43199H8.06801H2.0205Z",
    fill: "#3E3F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.d05c909ea69eac6ba57ad74aaf20fc3b.svg";
export { ForwardRef as ReactComponent };